<template lang='pug'>
  button.digi-button.component(:type='type' :title='title')
    slot
      .icon
        slot(name='icon')
      .text
        slot(name='text')
</template>

<script>
  export default {
    name: 'digi-button.component',

    props: {
      type: { type: String, default: 'button' },
      title: String
    }
  }
</script>

<style scoped lang='stylus'>
  .digi-button
    background 0
    font-family inherit
    font-size inherit
    padding 8px 12px
    color var(--clr-btn)
    outline none
    text-shadow inherit
    border 1px solid rgba(50 20 100 .1 )
    box-shadow 0 0 2px 1px rgba( 255 255 255 1 ) inset
    height auto
    display flex
    align-items center
    justify-content center
    transition transform 320ms
    // border-radius 3px
    .icon
      font-size 1.5em
    .icon, .text
      padding 0 16px
    &:hover
      color white
      box-shadow var(--shadow-box)
      background var(--bg-nav)
      font-weight bold
      .icon, .text
        filter drop-shadow( 0 -1px 0 rgba( 0 0 0 .1 ) )
    &:active
      transform scale(.88)
      box-shadow none

  .digi-button.large
    padding 12px 24px
    .icon
      font-size 1.5em
    .text
      font-size 1.25em

  .digi-button.larger
    .icon
      font-size 1.75em
    .text
      font-size 1.5em

  .digi-button.round
    padding 0
    height 48px
    width 48px
    border-radius 50%
    .icon, .text
      border 0
      padding 0
    &:active
      box-shadow 0 0 7px 1px rgba( 255 255 255 1 )

  .digi-button.round.large
    height 52px
    width 52px

  .digi-button.small
    .icon
      font-size 1.25em

  .digi-button.smaller
    padding 0
    .icon
      font-size 1.12em
  
  .digi-button.smallest
    padding 0
    .icon
      font-size .96em

  .digi-button.round.small
    height 42px
    width 42px
    font-size .88em

  .digi-button.round.smaller
    height 36px
    width 36px
    font-size .64em

  .digi-button.secondary
    @extend .digi-button.round
    margin-left auto
    vertical-align middle
    .icon
      display flex
      align-items center
      justify-content center
      svg
        margin-bottom 3px
        height 100%

  .digi-button.primary
    @extend .digi-button.round, .digi-button.round.large
    color var(--clr-light)
    box-shadow var(--shadow-box)
    margin 0
    background var(--bg-button)
    opacity .25
    &.actionable
      opacity 1
    .icon
      filter drop-shadow( 0 -1px 0 rgba( 0 0 0 .15 ) )
    &:active
      transform rotateZ(360deg) scale(.75)

  .digi-button.basic
    border 0
    .icon, .text
      filter none
    &:hover
      background 0
      filter drop-shadow( 0 0 12px white )

  .digi-button.active:hover
    filter drop-shadow( 0 0 12px white )

  .digi-button.text-only
    padding 12px 24px
    .icon
      display none

  .digi-button.icon-only
    padding 4px 12px
    box-shadow none
    display flex
    justify-content center
    align-items center
    .icon
      padding 0
    .text
      display none

  .digi-button.combo
    .icon
      border-right 1px dotted rgba( 0 0 0 .2 )

  .digi-button.dark
    color rgba( 0 0 0 .32 )
    background rgba( 255 255 255 .32 )
    border 1px solid rgba( 0 0 0 .1 )
    border-radius 3px
    &:hover, &.active
      box-shadow 0 0 8px 0 rgba( 0 0 0 .2 )
      filter drop-shadow( 0 0 4px rgba( 255 255 255 .48 ) )
      color rgba( 255 255 255 .76 )
      background rgba( 0 0 0 .24 )
    &:active
      box-shadow none

  .digi-button.light
    @extend .digi-button.dark
    color rgba( 255 255 255 .24 )
    background rgba( 0 0 0 .16 )
    &:hover, &.active
      color rgba( 0 0 0 .48 )
      background rgba( 255 255 255 .12 )
</style>
